// extracted by mini-css-extract-plugin
export default {"subLabel":"issue_type_select_subLabel__qIhlY"};